import Button from "components/BaseWidgets/button";
import "./style.scss";
import Skeleton from "components/BaseWidgets/skeleton";
import Tooltip from "components/BaseWidgets/toolTip";
import useMediaQuery from "hooks/useMediaQuery";

function JewelCard({ blog, className, isLoading, onToggle, isExpanded }) {
  const isTablet = useMediaQuery("(max-width: 1235px)");

  const HEADING_MAX = isTablet ? 25 : 40;
  const DESCRIPTION_MAX = isTablet ? 75 : 100;

  const handleClick = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };


  const getShortheading = (headText = "", maxLength) => {
    if (headText.length > maxLength) {
      return {
        headText: headText.slice(0, maxLength) + "...",
        Truncated: true,
      };
    }
    return { headText, Truncated: false };
  };

  const { headText, Truncated } = getShortheading(blog?.heading || "", HEADING_MAX);

  const getShortDescription = (text = "", maxLength) => {
    if (text.length > maxLength) {
      return { text: text.slice(0, maxLength) + "...", isTruncated: true };
    }
    return { text, isTruncated: false };
  };
  const { text, isTruncated } = getShortDescription(blog?.description || "", DESCRIPTION_MAX);

  if (isLoading) return <Skeleton label={false} height={300} />;

  return (
    <div className={`card-wrapper ${isExpanded ? "expanded-wrapper" : ""}`}>
      <div className={`wedding-card ${className || ""}`}>
        <div
          onClick={() => handleClick(blog?.website)}
          className="image-container"
        >
          <img
            src={blog?.image}
            alt={`Image for ${blog?.heading}`}
            className="main-image"
          />
        </div>
        <div className="content">
          <div className="text-group">
            <span className="category">{blog?.store_name}</span>
            <h3 className="title">
              {Truncated ? (
                <Tooltip title={blog?.heading}>
                  <span>{headText}</span>
                </Tooltip>
              ) : (
                headText
              )}
            </h3>
            {/* <h3 className="title">{blog?.heading}</h3> */}
            <div className="description font-title-xs fw-400 flex flex-col">
              {isExpanded ? blog?.description : text}
              {isTruncated && (
                <Button
                  variant="link"
                  className="readMore"
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggle();
                  }}
                >
                  {isExpanded ? "Read less" : "Read more"}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JewelCard;
